import * as React from "react";
import type { SVGProps } from "react";
const SvgTennisBall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 12c0-2.91-1.26-5.53-3.25-7.35v-.01c-.01-.01-.03-.02-.04-.03-1.78-1.61-4.12-2.6-6.7-2.6s-4.94.98-6.72 2.59c-.01.01-.03.02-.04.03v.01C3.26 6.47 2 9.09 2 12s1.26 5.53 3.25 7.35v.01c.01.01.02.01.04.03C7.07 21 9.42 22 12 22s4.93-.99 6.71-2.61c.01-.01.03-.01.04-.03v-.01C20.74 17.52 22 14.91 22 12Zm-2 0c0 2.02-.76 3.86-2 5.27-2.67-3.04-2.62-7.57 0-10.55 1.24 1.41 2 3.25 2 5.27V12ZM4 12c0-2.02.76-3.86 2-5.27 2.61 2.98 2.67 7.5 0 10.55-1.24-1.41-2-3.25-2-5.27V12Zm3.49 6.6c3.35-3.81 3.28-9.48 0-13.21 1.28-.88 2.84-1.4 4.51-1.4s3.22.52 4.51 1.4c-3.28 3.73-3.35 9.4 0 13.21-1.28.88-2.84 1.4-4.51 1.4s-3.22-.52-4.51-1.4Z"
    />
  </svg>
);
export default SvgTennisBall;
